export default {
  path: '/set',
  meta: {
    title: '设置',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/set`),
}



// WEBPACK FOOTER //
// ./src/views/Setting/router.js